import { render, staticRenderFns } from "./Train.vue?vue&type=template&id=6a31ac2a&scoped=true&"
import script from "./Train.vue?vue&type=script&lang=js&"
export * from "./Train.vue?vue&type=script&lang=js&"
import style0 from "./Train.vue?vue&type=style&index=0&id=6a31ac2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a31ac2a",
  null
  
)

export default component.exports